import clsx from 'clsx';
import { PlayerOnPitch } from '@/ui/components';
import type { LineupLineProps } from './Lineup.types';

export function LineupLine(props: LineupLineProps) {
  const { players, jerseySrc, enabledStats, width } = props;

  const hasMoreThanTwoPlayers = players.length > 2;

  return (
    <div
      className={clsx(
        'flex',
        'not-last:min-h-0',
        hasMoreThanTwoPlayers ? 'justify-between' : 'justify-center',
      )}
      style={{ width }}
    >
      {players.map((player) => (
        <PlayerOnPitch
          key={`${player.name}-${player.goals}-${player.assists}`}
          className={clsx(hasMoreThanTwoPlayers && 'first:top-[12px] last:top-[12px]')}
          jerseySrc={jerseySrc}
          playerName={player.name}
          goals={player.goals ?? 0}
          assists={player.assists ?? 0}
          activeStat={enabledStats}
        />
      ))}
    </div>
  );
}
